"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN = void 0;
const tab_1 = require("../../../tab");
exports.IN = {
    description: 'Find an exact match of {match_string} inside {values_to_search}. Returning true if matches, false otherwise',
    arg_names: ['match_string', 'values_to_search'],
    args_def: [
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
            variadic: true,
        },
    ],
    args_description: [
        'match string',
        'value or list of values to search (can be a stringified JSON array or values separated by comma)',
    ],
    return_type: tab_1.ColumnType.BOOLEAN,
};
